import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { LandingPageInteractiveEnvironments } from "../interactive/landingPageInteractiveEnvironments";

export default function InteractiveMainPage() {
  useEffect(() => {
    document.title = "PHIL App - Interactive Environments";
  }, []);

  return (
    <div className="app_content">
      <Container fluid>
        <h2 className="mb-0">Interactive Environments Inside My Activities</h2>
        <LandingPageInteractiveEnvironments myInteractiveEnvironments={false} />
      </Container>
    </div>
  );
}
